import { SKINCARE_INGREDIENTS } from 'lib/constants/routes';

import { ResultLayout } from '../layouts/ResultLayout';
import type { NavigationPayload } from '../SearchResults';

interface SkincareIngredientsProps {
  onNavigate: ({ title, path }: NavigationPayload) => void;
}

const title = 'Ingredients';

export function SkincareIngredients({ onNavigate }: SkincareIngredientsProps) {
  const path = SKINCARE_INGREDIENTS;

  return (
    <ResultLayout
      href={path}
      title={title}
      onNavigate={() => onNavigate({ title, path })}
      type="Skincare"
    />
  );
}
